module.exports = __webpack_public_path__ + "fonts/videogular.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/@ps/common-core/dist/fonts/videogular.ttf
// module id = ./node_modules/@ps/common-core/dist/fonts/videogular.ttf
// module chunks = 1